module.exports = __webpack_public_path__ + "img/30_33.5202859b.png";